var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26692(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26692",
    "data-name": "Group 26692",
    transform: "translate(-424 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(424 788)",
    fill: "#8430c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23250",
    "data-name": "Path 23250",
    d: "M372.166,69.195a4.692,4.692,0,0,1,4.69,4.69V76.23H334.647V73.885a4.689,4.689,0,0,1,4.69-4.69Zm4.69,28.14a4.694,4.694,0,0,1-4.69,4.69H339.337a4.691,4.691,0,0,1-4.69-4.69V83.265h42.209Zm-34-4.69a1.172,1.172,0,0,0,0,2.345h4.69a1.172,1.172,0,0,0,0-2.345Zm9.38,2.345h9.38a1.172,1.172,0,1,0,0-2.345h-9.38a1.172,1.172,0,0,0,0,2.345",
    transform: "translate(104.353 738.805)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26692);
export default __webpack_public_path__ + "static/media/Group 26692.316c2a0afefd2bc012a963feb5f8619b.svg";
export { ForwardRef as ReactComponent };